'use strict';

angular.module('atex.aceui.service').factory('ViewService',
['$q', '$rootScope', 'AuthenticationService', 'ApplicationConfigurationService',

  function($q, $rootScope, AuthenticationService, ApplicationConfigurationService) {
    var serviceHandler = undefined;

    var handler = function() {
      if (serviceHandler !== undefined) {
        return $q.when(serviceHandler);
      }

      return ApplicationConfigurationService.getServiceConfigurationFor('ViewService').then(function(configuration) {
        var serviceUrl = atex.aceui.ServiceUtils.calculateServiceUrl(configuration, 'view');

        var serviceSettings = { customQ: atex.aceui.AngularUtils.applyingQ($q, $rootScope), cacheBusting: atex.aceui.BrowserUtils.isSafariBrowser() };
        serviceHandler = atex.aceui.service.ViewService(serviceUrl, serviceSettings);

        return serviceHandler;
      });
    };

    return {
      /**
       * Assigns a content version to a view.
       * Wraps the request with an authentication guard.
       *
       * @param {Object} transferInfo - a transfer info object containing request details
       * @param {string} transferInfo.version - the version to assign to the view
       * @param {string} transferInfo.view - the view to assign the version to
       * @param {string} transferInfo.revision - the last known revision of the content
       *
       * @typedef {Object} AssignToViewResult - an object containing the result of view assign request
       * @property {string} revision - the new revision of the updated content
       *
       * @see atex.aceui.service.ViewService
       * @see AuthenticationService
       *
       * @returns {Promise.<AssignToViewResult, atex.aceui.error.Error>}
       */
      assignToView: function(transferInfo) {
        return AuthenticationService.callWithAuthentication(function(currentUser) {
          return handler().then(function(serviceHandler) {
            return serviceHandler.assignToView(_.extend(transferInfo, { authToken: currentUser.token }));
          });
        });
      },

      /**
       * Assigns a content version to a symbolic view.
       * Wraps the request with an authentication guard.
       *
       * @param {Object} transferInfo - a transfer info object containing request details
       * @param {string} transferInfo.alias - the alias of the content to assign to the symbolic view
       * @param {string} transferInfo.view - the symbolic view to assign the version to
       * @param {string} transferInfo.targetView - the target view of the symbolic view
       * @param {string} transferInfo.revision - the last known revision of the content
       * @param {string} transferInfo.authToken - the authorization token to use for the request
       *
       * @typedef {Object} AssignToViewResult - an object containing the result of view assign request
       * @property {string} revision - the new revision of the updated content
       *
       * @see atex.aceui.service.ViewService
       * @see AuthenticationService
       *
       * @returns {Promise.<AssignToViewResult, atex.aceui.error.Error>}
       */
      assignToSymbolicView: function(transferInfo) {
        return AuthenticationService.callWithAuthentication(function(currentUser) {
          return handler().then(function(serviceHandler) {
            return serviceHandler.assignToSymbolicView(_.extend(transferInfo, { authToken: currentUser.token }));
          });
        });
      },

      /**
       * Unassigns a content from a view.
       * Wraps the request with an authentication guard.
       *
       * @param {Object} transferInfo - a transfer info object containing request details
       * @param {string} transferInfo.alias - the alias of the content to unassign from the view
       * @param {string} transferInfo.view - the view to unassign the content from
       * @param {string} transferInfo.revision - the last known revision of the content
       * @param {string} transferInfo.authToken - the authorization token to use for the request
       *
       * @see atex.aceui.service.ViewService
       * @see AuthenticationService
       *
       * @returns {Promise.<{Object}, atex.aceui.error.Error>}
       */
      unassignFromView: function(transferInfo) {
        return AuthenticationService.callWithAuthentication(function(currentUser) {
          return handler().then(function(serviceHandler) {
            return serviceHandler.unassignFromView(_.extend(transferInfo, { authToken: currentUser.token }));
          });
        });
      }
    };
  }
]);
